import { Stack } from "@mui/material";
import { Helpbar } from "../snack-bar";
import { useTheme } from "@quales/utils/theme";
import React from "react";
import { useWindowDimensions } from "@quales/utils/hooks";

interface SubHeaderProps {
  children: React.ReactNode;
  cookieName?: string;
  helpText?: string;
}

export const SubHeader = (props: SubHeaderProps) => {
  const theme = useTheme();
  const windowSize = useWindowDimensions();
  const { children, cookieName, helpText } = props;

  const handleHelpbarClose = () => {};

  return (
    <Stack id="Subheader" marginBottom={5} width={"100%"}>
      {cookieName && (
        <Stack sx={{ width: "100%" }}>
          <Helpbar
            cookieName={cookieName}
            message={helpText || ""}
            onClose={handleHelpbarClose}
          ></Helpbar>
        </Stack>
      )}
      <Stack
        width={"100%"}
        padding={2}
        id="SubHeaderInnerStack"
        height={"100%"}
        sx={{
          backgroundColor: theme.appColors.surfaceContainerLowest,
          borderRadius: 12,
          paddingY: 6,
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default SubHeader;
